import React from "react";
//import "./Template2.css"; // Assuming the provided CSS is used

const Template2 = ({}) => {

  return (
    <></>
  );
};

export default Template2;
